import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Button,
  Row,
  Col,
  Input
} from 'reactstrap';
import * as commonActions from '@common/common.action';
import { useDispatch } from 'react-redux';
import { arquivamentoTipoEmum } from '../../../../arquivamento.utils';
import IntlMessage from '../../../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

export default function ModalDetalhes (props) {
  const [modalAberto, setModalAberto] = useState(false);
  const backdrop = !props.backdrop ? false : props.backdrop;
  const keyboard = props.keyboard === undefined ? true : props.keyboard;
  const dispatch = useDispatch();
  const intl = useIntl()

  useEffect(() => {
    setModalAberto(props.showModalDetalhes);
    dispatch(commonActions.showModal(props.showModalDetalhes));
  }, [props.showModalDetalhes]);

  function toggle () {
    setModalAberto(!modalAberto);
    dispatch(commonActions.showModal(!modalAberto));
    props.onModal(!modalAberto);
  }

  return (
    <React.Fragment>
      <div>
        <Modal
          className='modal-lg'
          backdrop={backdrop}
          keyboard={keyboard}
          centered
          isOpen={modalAberto}
          toggle={toggle}
        >
          <ModalHeader toggle={!props.close ? toggle : props.close}>
            <div>{`${intl.formatMessage({id: 'general.materialArchiving.details'})} ${props.itemSelecionado.numero}`}</div>
          </ModalHeader>
          {props.itemSelecionado && (
            <ModalBody>
              <Row>
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.exam" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.nrExame}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.report" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.laudo}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.medicalRecord" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.prontuario}
                    />
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.completionDate" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.dataFinalLaudo}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col lg={9}>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.patient" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.pacienteNome}
                    />
                  </FormGroup>
                </Col>

                <Col lg={3}>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.request" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.dtRequisicao}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col lg={9}>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.requester" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.requisitante}
                    />
                  </FormGroup>
                </Col>
                <Col lg={3}>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.material" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.material}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.destiny" />:</Label>
                    <Input
                      disabled={true}
                      value={props.itemSelecionado.destinoEntrega}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id="general.materialArchiving.location" />:</Label>
                    <Input
                      type='textarea'
                      rows={3}
                      disabled={true}
                      value={props.itemSelecionado.dsLocalizacao}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
          )}
          <ModalFooter>
            <Button
              onClick={!props.cancelar ? toggle : props.cancelar}
              className={`button-cancel`}
              color='secondary'
            >
              <IntlMessage id="general.materialArchiving.close" />
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Requisicao/modais/Detalhes/index.js